import { Sprite, SpriteMaterial, TextureLoader, Vector3, Group } from "three";
import { Font } from "three/examples/jsm/loaders/FontLoader";
import { TextGeometry } from "three/examples/jsm/geometries/TextGeometry";
import mark from "../../../images/icons/mark.png";
import font from "../../../fonts/RoundedMplus1c_Regular.json";
import { Viewer } from "../viewer";

export class PickPoint {
  private _viewer: Viewer;

  private _id: string;
  private _pickPointGroup: Group;

  private _mark: Sprite;
  private _material: SpriteMaterial;
  private _pointName: string;

  private _textMesh: Sprite;
  private _font: Font;
  private _textGeometry: TextGeometry;
  private _textMaterial: SpriteMaterial;

  constructor(id: string, name: string, viewer: Viewer) { //, canvas: HTMLCanvasElement
    this._id = id;
    this._pickPointGroup = new Group();

    // mark
    this._material = new SpriteMaterial({
      color: "#FF0000",
      map: new TextureLoader().load(mark, ()=> {viewer.updateRenderer()}),
      sizeAttenuation: false,
      depthTest: false
    });
    this._mark = new Sprite(this._material);
    this._pickPointGroup.add(this._mark);

    this._pointName = name ? name : "";
    /* use text geometry */
    this._font = new Font(font);
    this._textGeometry = new TextGeometry(name, {
      font: this._font,
      size: 0.05,
      height: 0.2
    });
    this._textMaterial = new SpriteMaterial({
      color: "#FF0000",
      sizeAttenuation: false,
      depthTest: false
    });
    this._textMesh = new Sprite(this._textMaterial);
    this._textMesh.geometry = this._textGeometry;
    this._pickPointGroup.add(this._textMesh);
    const markSize = new Vector3();
    this._mark.geometry.computeBoundingBox();
    this._mark.geometry.boundingBox.getSize(markSize);
    this._textMesh.position.y = this._mark.position.y + 0.2
    this._textMesh.position.x = this._mark.position.x + 0.2;
  }

  dispose(){
    this._pickPointGroup.children.forEach(c=>{
      c.removeFromParent();
      c = undefined;      
    });
    this._pickPointGroup.removeFromParent();
    this._pickPointGroup = undefined;
  }

  public getId(): string {
    return this._id;
  }

  public getPickPointGroup(): Group {
    return this._pickPointGroup;
  }

  public setPosition(position: Vector3, offset: Vector3 = new Vector3()): void {
    this._pickPointGroup.position.set(position.x - offset.x, position.y - offset.y, position.z - offset.z);
  }

  public setName(name: string): void {
    this._textMesh.geometry = new TextGeometry(name, {
      font: this._font,
      size: 0.05,
      height: 0.2,
    });
  }

  public setTextPosition(scale: number): void {
    const markSize = new Vector3();
    this._mark.geometry.computeBoundingBox();
    this._mark.geometry.boundingBox.getSize(markSize);
    this._textMesh.position.y = this._mark.position.y + 0.2;
    this._textMesh.position.x = this._mark.position.x + 0.2;
    this._mark.scale.set(scale, scale, 1)
    this._textMesh.scale.set(7 * scale, 7 * scale, 1)
  }

  public setVisibility(visibility: boolean){
    this._pickPointGroup.visible = visibility;
  }
}
